import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdaptiveaccessDashboardService } from 'src/app/features/ada-access/auth-tool-home/dashboard.service';
import { AdaptiveAccessReportService } from 'src/app/features/ada-access/reports/reports.service';


@Injectable({ providedIn: 'root' })
export class AdaptiveAccessDashboardDataResolver implements Resolve<any> {
  constructor(
    private dashboardService: AdaptiveaccessDashboardService,
    private reportService: AdaptiveAccessReportService
  ) {}

  resolve(): Observable<any> {
    const filter = 'all_time';

    return forkJoin({
      dashBoardData: this.dashboardService.getAcDashboardData(),
      data: this.reportService.getAcReports(filter),
      chartdata: this.dashboardService.getAcDashboardChartData(filter)
    }).pipe(map(response => response));
  }
}